// extracted by mini-css-extract-plugin
export default {"chart":"pieChart_chart__Vj+RB"};